// components/ModelsCreationsLayout.tsx
"use client";
import { Text, Flex, Box, SimpleGrid, Button } from "@chakra-ui/react";
import Jumbotron from "./Jumbotron";
import { useRouter } from "next/navigation";
import { Model } from "types";
import { getJwtToken } from "libs/utils";

const ModelsCreationsLayout = ({
  JumbotronTitle,
  JumbotronSubtitle,
  data,
  renderCard,
  fetchNextPage,
  hasNextPage,
  onSortChange,
  onFilterChange,
  sortType,
  filterType,
}: {
  JumbotronTitle: string;
  data: Model[] | undefined;
  JumbotronSubtitle?: string | boolean;
  renderCard: any;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  selectedTags: string[];
  toggleTag?: (tag: string) => void;
  onSortChange?: (sortType: boolean) => void;
  onFilterChange?: (filterType: string) => void;
  sortType?: boolean;
  filterType?: string;
}) => {
  const router = useRouter();
  const isAuthenticated = Boolean(getJwtToken());

  const sortedData = data
    ? [...data].sort((a, b) => (b.isFlux ? 1 : 0) - (a.isFlux ? 1 : 0))
    : [];
  return (
    <Flex direction="column">
      <Jumbotron height="100%">
        <Flex h="220px" mb="0" justify="end" direction="column" textAlign="center">
          <Flex direction="column" align="center">
            <Text
              fontSize={{ base: "38px", lg: "58px" }}
              fontWeight="semibold"
              style={{
                background: "linear-gradient(to right,  #FFE1FF 40%, #A4DBEE 60%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                MozBackgroundClip: "text",
              }}
              w={{ base: "310px", lg: "400px" }}
              mb={JumbotronSubtitle ? "0xp" : "50px"}
            >
              {JumbotronTitle}
            </Text>
            {JumbotronSubtitle && (
              <Flex direction="column">
                <Text
                  fontSize={{ base: "18px", lg: "26px" }}
                  fontWeight="semibold"
                  style={{
                    background: "linear-gradient(to right,  #FFE1FF 40%, #A4DBEE 60%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    MozBackgroundClip: "text",
                  }}
                  w={{ base: "310px", lg: "420px" }}
                  mb="30px"
                >
                  {JumbotronSubtitle}
                </Text>
                <Button
                  _hover={{ opacity: 0.9, bg: "button.500" }}
                  bg="button.500"
                  zIndex={5}
                  onClick={() => router.push("/train")}
                  color="white"
                >
                  Create your own model
                </Button>
              </Flex>
            )}
          </Flex>
        </Flex>
      </Jumbotron>
      <Flex mt="20px" direction="column" w="100%" align="center">
        <Flex
          direction="column"
          w={{ base: "full", lg: "auto" }}
          px={{ base: 6, lg: 0 }}
          align={{ base: "center", lg: "start" }}
        >
          {onSortChange && onFilterChange && (
            <>
              <Flex
                w="100%"
                direction={{ base: "column", lg: "row" }}
                justify="space-between"
                align="center"
              >
                <Flex align="center">
                  <Text fontWeight={700} color="white">
                    Sort by
                  </Text>
                  <Button
                    onClick={() => onSortChange(true)}
                    ml="4"
                    borderRadius="32px"
                    border="2px solid #2C314D"
                    bg={sortType ? "white" : "transparent"}
                  >
                    <Text color="gray.500">Popular</Text>
                  </Button>
                  {isAuthenticated && (
                  <Button
                    onClick={() => onSortChange(false)}
                    ml="2"
                    borderRadius="32px"
                    border="2px solid #2C314D"
                    bg={!sortType ? "white" : "transparent"}
                  >
                    <Text color="gray.500">Created</Text>
                  </Button>
                  )}
                </Flex>
                <Flex mt={{ base: "15px", lg: "0px" }} align="center">
                  <Text fontWeight={700} color="white">
                    Filter
                  </Text>
                  <Button
                    onClick={() => onFilterChange("woman")}
                    ml="4"
                    borderRadius="32px"
                    border="2px solid #2C314D"
                    bg={filterType === "woman" ? "white" : "transparent"}
                  >
                    <Text color="gray.500">Female</Text>
                  </Button>
                  <Button
                    onClick={() => onFilterChange("man")}
                    ml="2"
                    borderRadius="32px"
                    border="2px solid #2C314D"
                    bg={filterType === "man" ? "white" : "transparent"}
                  >
                    <Text color="gray.500">Male</Text>
                  </Button>
                </Flex>
              </Flex>
            </>
          )}

          <SimpleGrid
            mt="25px"
            gap={{ base: "28px", md: "24px" }}
            columns={{ base: 2, md: 3, lg: 4 }}
          >
            {sortedData?.map((model: Model) => renderCard(model))}
          </SimpleGrid>
          {hasNextPage && (
            <Button
              onClick={fetchNextPage}
              color="white"
              mt="35px"
              borderRadius="16px"
              bg="#FF1B6D"
              _hover={{ opacity: 0.9, bg: "#FF1B6D" }}
            >
              Load More
            </Button>
          )}
        </Flex>
      </Flex>
      <Box h="180px" />
    </Flex>
  );
};

export default ModelsCreationsLayout;
